<style scoped>
    .notification {
        padding: .5em 1em;
        position: relative;
        border-radius: 5px;
        margin: 1em 0;
        min-width: 60%;
        max-width: 100%;
        background: #fff;
        color: #000;
        padding: .8em;
        overflow: auto;
        box-shadow: 0.1em 0.2em 0.5em #e5e5e5;
        display: flex;
        flex-direction: row;
    }
    .notification ul {
        list-style-type: disc;
        margin: .3em 0;
        padding-left: 2em;
    }
    .notification.success {
        border: 1px solid #0c0;
    }
    .notification.important {
        border: 1px solid #f97a6b;
    }
    .notification.warning {
        border: 1px solid #f8bd00;
    }
    .notification.error {
        border: 1px solid #f97a6b;
    }
    .notification.error .icon {
        color: #f97a6b;
    }
    .notification.success {
        border: 1px solid #0c0;
    }
    .notification.success .icon {
        color: #0c0;
    }
    .notification.warning .icon {
        color: #f8bd00;
    }    
    .info {
        margin-left: 0;
        border: 1px solid #40b8ea;
    }
    .info-message , .success-icon, .attention {
        position: relative;
    }
    .info-message {
        color: #40b8ea;
    }
    .attention-message {
        color: #f97a6b;
    }
    .notification a {
        color: #326CA6;
    }
    .notification a:hover {
        cursor: pointer;
    }
    .icon-box, .notification-content {
        float:left;
    }
    .notification-content {
        width: 100%;
    }
    .icon-box {
        padding-top: 0.2em;
        margin-right: .5em;
    }
    .notification-content p {
        text-align: left;
        margin: .1em .2em;
        font-family: sans-serif;
        font-size: .8rem;
    }
    .notification-content p.error-text {
        margin-top: .8em;
    }
</style> 
<template>
	 <div class="notification" :class="cssClassFromKind">
        <div v-if="notificationIconName !== 'none'" class="icon-box">
            <icon :name="notificationIconName" class="icon" :class="notificationIconClass"></icon>
        </div>
        <div class="notification-content">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { NAMESPACE as APP_NAMESPACE } from '../store/modules/app.js';
    
    const KIND_SETTINGS = {
        ERROR: {
            iconClass: "error-message",
            iconName: "exclamation-circle"
        },
        SUCCESS: {
            iconClass: "success",
            iconName: "check-circle"
        },
        WARNING: {
            iconClass: "warning",
            iconName: "exclamation-triangle"
        }
    }
    export default{
        props: ["iconName", "iconClass", "kind"],
        computed: {
            notificationIconClass() {
                if (this.kind) {
                    return KIND_SETTINGS[this.kind].iconClass;
                }
                return this.iconClass;
            },
            notificationIconName() {
                if (this.iconName) {
                    return this.iconName;
                }
                return KIND_SETTINGS[this.kind].iconName;
            },
            cssClassFromKind() {
                if (this.kind) {
                    return this.kind.toLowerCase();
                }
                return "";
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Notification.vue